module.exports = __webpack_public_path__ + "img/ic_x_airlead.23f33097.svg";